
/**
 * @roxi/routify 2.18.0
 * File generated Sat Jul 31 2021 00:19:39 GMT+0200 (Mitteleuropäische Sommerzeit)
 */

export const __version = "2.18.0"
export const __timestamp = "2021-07-30T22:19:39.554Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports
import _base64 from '../src/pages/base64.svelte'
import _colors from '../src/pages/colors.svelte'
import _dev from '../src/pages/dev.svelte'
import _hash from '../src/pages/hash.svelte'
import _index from '../src/pages/index.svelte'
import _pwgen from '../src/pages/pwgen.svelte'
import __layout from '../src/pages/_layout.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isPage": true,
      "path": "/base64",
      "id": "_base64",
      "component": () => _base64
    },
    {
      "isPage": true,
      "path": "/colors",
      "id": "_colors",
      "component": () => _colors
    },
    {
      "isPage": true,
      "path": "/dev",
      "id": "_dev",
      "component": () => _dev
    },
    {
      "isPage": true,
      "path": "/hash",
      "id": "_hash",
      "component": () => _hash
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isPage": true,
      "path": "/pwgen",
      "id": "_pwgen",
      "component": () => _pwgen
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => __layout
}


export const {tree, routes} = buildClientTree(_tree)

